 <template>
  <vs-sidebar
    click-not-close
    position-right
    v-model="dialogShow"
    class="items-no-padding look-direct-rule-dialog sidebar-dialog">
    <div class="sidebar-content h-full">
      <div class="customizer-header flex items-center justify-between px-6 sliderbar-header">
        <div>
          {{title}}
        </div>
        <feather-icon icon="XIcon" @click.stop="closeHandle" class="cursor-pointer"></feather-icon>
      </div>
      <VuePerfectScrollbar class="scroll-area--customizer pt-4 pb-6 " :settings="settings" :key="$vs.rtl">
        <div class="content px-6">
<!--          订阅完需不需要关闭弹窗 todo-->
          <right-bar
            :is-border="true"
          ></right-bar>
        </div>
      </VuePerfectScrollbar>
    </div>
  </vs-sidebar>
</template>

<script>
import rightBar from "@/components/copyMaster/home/rightBar";
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { mapGetters } from 'vuex'
export default {
  name: "searchTradeDialog",
  components:{
    VuePerfectScrollbar,
    rightBar,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
    directRuleInfo:{
      type: Object,
      default(){
        return {
          levelName: '',
          custGroupList: [],
        }
      }
    },
    ruleList: {
      type: Array,
      default(){
        return [];
      }
    }
  },
  data() {
    let _this = this;
    return {
      settings: {
        maxScrollbarLength : 60,
        wheelSpeed         : .60,
      },
      title: _this.$t('copyMaster.Subscribe_to_Trader'),

    }
  },
  watch:{
    listRefresh(){
      this.close();
    }
  },
  computed: {
    ...mapGetters(['userInfo','themeColor','listRefresh']),
  },
  methods: {
    close(){
      this.$emit('close')
    },
    closeHandle() {
      this.close();
    },
    submitHandle(){
      this.close();
    },
    cancelHandle(){
      this.close();
    }
  },
}
</script>
<style lang="scss">
.look-direct-rule-dialog {
  .content {
  }
}
</style>
<style lang="scss">
.look-direct-rule-dialog {
  .vs-sidebar--items {

  }
  // 高度滑动有点问题 todo
  .scroll-area--customizer {
    height: calc(100% - 3rem);
  }
  .vs-sidebar {
    z-index: 1002;
    position: fixed;
    .sidebar-content {
    }
  }
  // sidebar弹框的遮罩层
  .vs-sidebar--background {
    z-index: 1001!important;
  }

  .footer-sidebar {
    padding: 20px 0;
    padding-right: 20px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .calcel-btn {
      margin-right: 10px;
    }
  }
}
</style>
